import PPAdressAutocomplete from "./PPAdressAutocomplete";
import PPaddMessageManagementForGF from "./PPaddMessageManagementForGF";

document.addEventListener('DOMContentLoaded', ()=> {

    document.querySelector('#input_19_15').setAttribute('readonly', 'readonly');

    const ppAddressAutocomplete = new PPAdressAutocomplete(
        'input_19_14',
        'input_19_15',
        'input_15',
        'validation_message_19_15'
    );
    ppAddressAutocomplete.main();

    //============================================================================
    const ppMessageManagement =  new PPaddMessageManagementForGF('#gform_19');
    ppMessageManagement.addElementsByID('4');
    ppMessageManagement.setElements();

});

